module.exports = __webpack_public_path__ + "img/bg_save_img01.4cc22271.png";